/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddOnModel } from '../models';
// @ts-ignore
import type { AddOnPatchModel } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * AddOnsApi - axios parameter creator
 * @export
 */
export const AddOnsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all add-ons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddOns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/addOns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Add Ons
         * @param {AddOnPatchModel} addOnPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddOn: async (addOnPatchModel: AddOnPatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOnPatchModel' is not null or undefined
            assertParamExists('patchAddOn', 'addOnPatchModel', addOnPatchModel)
            const localVarPath = `/api/v1/addOns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOnPatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddOnsApi - functional programming interface
 * @export
 */
export const AddOnsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddOnsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all add-ons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAddOns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddOnModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAddOns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddOnsApi.getAddOns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Add Ons
         * @param {AddOnPatchModel} addOnPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAddOn(addOnPatchModel: AddOnPatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAddOn(addOnPatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddOnsApi.patchAddOn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddOnsApi - factory interface
 * @export
 */
export const AddOnsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddOnsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all add-ons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAddOns(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddOnModel>> {
            return localVarFp.getAddOns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Add Ons
         * @param {AddOnPatchModel} addOnPatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAddOn(addOnPatchModel: AddOnPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchAddOn(addOnPatchModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddOnsApi - interface
 * @export
 * @interface AddOnsApi
 */
export interface AddOnsApiInterface {
    /**
     * 
     * @summary Get all add-ons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddOnsApiInterface
     */
    getAddOns(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddOnModel>>;

    /**
     * 
     * @summary Update Add Ons
     * @param {AddOnPatchModel} addOnPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddOnsApiInterface
     */
    patchAddOn(addOnPatchModel: AddOnPatchModel, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * AddOnsApi - object-oriented interface
 * @export
 * @class AddOnsApi
 * @extends {BaseAPI}
 */
export class AddOnsApi extends BaseAPI implements AddOnsApiInterface {
    /**
     * 
     * @summary Get all add-ons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddOnsApi
     */
    public getAddOns(options?: RawAxiosRequestConfig) {
        return AddOnsApiFp(this.configuration).getAddOns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Add Ons
     * @param {AddOnPatchModel} addOnPatchModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddOnsApi
     */
    public patchAddOn(addOnPatchModel: AddOnPatchModel, options?: RawAxiosRequestConfig) {
        return AddOnsApiFp(this.configuration).patchAddOn(addOnPatchModel, options).then((request) => request(this.axios, this.basePath));
    }
}

